import { render } from "./Changepassword.vue?vue&type=template&id=c0d94e6e&scoped=true"
import script from "./Changepassword.vue?vue&type=script&lang=js"
export * from "./Changepassword.vue?vue&type=script&lang=js"

import "./Changepassword.vue?vue&type=style&index=0&id=c0d94e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d94e6e"]])

export default __exports__